<template>
  <span class="column-header">
    <span>{{ column.title }}</span>
    <column-select-filter
      v-if="type === 'select'"
      type="experience"
      :field="field"
      label=""
      :values="values"
      :parse-value="name => name"
    />
    <column-number-filter v-else type="experience" :field="field" />
  </span>
</template>

<script>
import ColumnSelectFilter from '@/components/filters/helpers/column-select-filter'
import ColumnNumberFilter from '@/components/filters/helpers/column-number-filter'

const sortFunction = (a, b) => {
  const first = a && typeof a === 'string' ? a.toLowerCase() : ''
  const second = b && typeof b === 'string' ? b.toLowerCase() : ''

  if (first > second) return 1
  if (first < second) return -1

  return 0
}

export default {
  props: ['column', 'field', 'type', 'request', 'index'],
  components: {
    ColumnSelectFilter,
    ColumnNumberFilter
  },
  data () {
    return {
      values: []
    }
  },
  watch: {
    '$store.state.experience.uniqueValuesUpdated': {
      handler (val) {
        this.setValues()
      }
    }
  },
  methods: {
    setValues () {
      const { uniqueValues } = this.$store.state.experience
      const values = uniqueValues[this.field] || []

      this.values = values
        .map(value => {
          if (value === null || typeof value === 'boolean') {
            return String(value)
          }
          return value
        })
        .sort(sortFunction) || []
    }
  },
  created () {
    this.setValues()
  }
}
</script>

<style lang="less">
.column-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
}
</style>
